import(/* webpackMode: "eager" */ "/home/ubuntu/download/698e613ff782d500148d0ff0/sdsa_website/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698e613ff782d500148d0ff0/sdsa_website/src/components/common/WhatsAppButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698e613ff782d500148d0ff0/sdsa_website/src/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/698e613ff782d500148d0ff0/sdsa_website/src/styles/index.css");
